<template>
  <div>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">单位名称<span class="required">*</span> </span>
          <a-tooltip placement="topLeft" :title="form.unitName">
            <div>
              <a-input
                v-if="form.id"
                class="w300"
                placeholder="请添加"
                v-model="form.unitName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in app.organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">责任人<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入责任人"
            v-model="form.responsiblePeople"
            :disabled="disabled"
            @change="emitChange('responsiblePeople', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">责任人电话<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入责任人电话"
            v-model="form.responsiblePeoplePhone"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">防汛重点位置<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入防汛重点位置"
            v-model="form.address"
            :disabled="disabled"
            @change="emitChange('address', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >是否配备防汛物资<span class="required">*</span>
          </span>
          <a-select
            class="w300"
            v-model="form.goodsMaterials"
            placeholder="请选择是否配备防汛物资"
            :disabled="disabled"
            @change="emitChange()"
          >
            <template v-for="(item, index) in bytype.whetherList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <br />
        <a-descriptions-item label="备注">
          <a-input
            class="w500"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入备注"
            v-model="form.remark"
            :disabled="disabled"
            @change="emitChange('remark', 200)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      form: {}
    }
  },
  props: ['disabled', 'resData', 'formData'],
  model: {
    event: 'input',
    prop: 'formData'
  },
  watch: {
    resData(val) {
      if (val) {
        this.form = val
      }
    }
  },
  computed: {
    ...mapState(['app', 'bytype'])
  },

  mounted() {
    this.getorganizationUserList()
    this.getWhetherList()
    if (!this.form.id) {
      // 新增
      this.$set(
        this.form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  methods: {
    ...mapActions(['getorganizationUserList', 'getWhetherList']),
    // 值更改时 向父组件传值
    emitChange(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.form)
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.form[v].length > maxNum) {
        this.form[v] = this.form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/baseInfoManagement/floodControl/components/formBaseInfo.vue